
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enHeader from './locales/en/header.json';
import enHome from './locales/en/home.json';
import enLeagues from './locales/en/leagues.json';
import enTeams from './locales/en/teams.json';
import enNews from './locales/en/news.json';
import enRules from './locales/en/rules.json';
import enStandings from './locales/en/standings.json';
import enAuth from './locales/en/auth.json';
import enAdmin from './locales/en/admin.json';
import enTransfers from './locales/en/transfers.json';
import enContracts from './locales/en/contracts.json';
import enPlayer from './locales/en/player.json';
import enTickets from './locales/en/tickets.json';
import enNotifications from './locales/en/notifications.json';
import enTransfercenter from './locales/en/transfercenter.json';
import enCaptain from './locales/en/captain.json';

// Import German translations
import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deHeader from './locales/de/header.json';
import deHome from './locales/de/home.json';
import deLeagues from './locales/de/leagues.json';
import deTeams from './locales/de/teams.json';
import deRules from './locales/de/rules.json';
import deStandings from './locales/de/standings.json';
import deNews from './locales/de/news.json';
import deAuth from './locales/de/auth.json';
import deAdmin from './locales/de/admin.json';
import deContracts from './locales/de/contracts.json';
import deTransfers from './locales/de/transfers.json';
import dePlayer from './locales/de/player.json';
import deTickets from './locales/de/tickets.json';
import deNotifications from './locales/de/notifications.json';
import deTransfercenter from './locales/de/transfercenter.json';
import deCaptain from './locales/de/captain.json';

// Import Turkish translations
import trCommon from './locales/tr/common.json';
import trNews from './locales/tr/news.json';
import trHome from './locales/tr/home.json';
import trTeams from './locales/tr/teams.json';
import trLeagues from './locales/tr/leagues.json';
import trDashboard from './locales/tr/dashboard.json';
import trHeader from './locales/tr/header.json';
import trRules from './locales/tr/rules.json';
import trContracts from './locales/tr/contracts.json';
import trAuth from './locales/tr/auth.json';
import trAdmin from './locales/tr/admin.json';
import trTransfers from './locales/tr/transfers.json';
import trStandings from './locales/tr/standings.json';
import trPlayer from './locales/tr/player.json';
import trTickets from './locales/tr/tickets.json';
import trNotifications from './locales/tr/notifications.json';
import trTransfercenter from './locales/tr/transfercenter.json';
import trCaptain from './locales/tr/captain.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    resources: {
      en: {
        translation: {
          ...enCommon,
          ...enHeader,
          ...enHome,
          ...enLeagues,
          ...enTeams,
          ...enNews,
          ...enStandings,
          ...enAuth,
          ...enAdmin,
          ...enPlayer,
          ...enTransfercenter,
          ...enCaptain,
          dashboard: enDashboard.dashboard,
          transfers: enTransfers,
          contracts: enContracts,
          player: enPlayer,
          common: {
            offline: "Currently Offline",
            live: "LIVE",
            viewers: "viewers",
            watchNow: "Watch Now",
            openInBrowser: "Open in Browser"
          },
          rules: {
            title: "Rules",
            ...enRules
          }
        },
        tickets: enTickets,
        notifications: enNotifications
      },
      de: {
        translation: {
          ...deCommon,
          ...deHeader,
          ...deHome,
          ...deLeagues,
          ...deTeams,
          ...deNews,
          ...deStandings,
          ...deRules,
          ...deAuth,
          ...deAdmin,
          ...deTransfercenter,
          ...deCaptain,
          player: dePlayer,
          dashboard: deDashboard.dashboard,
          transfers: deTransfers,
          contracts: deContracts,
          common: {
            offline: "Derzeit Offline",
            live: "LIVE",
            viewers: "Zuschauer",
            watchNow: "Jetzt Ansehen",
            openInBrowser: "Im Browser Öffnen"
          }
        },
        tickets: deTickets,
        notifications: deNotifications
      },
      tr: { 
        translation: {
          ...trCommon,
          ...trNews,
          ...trHome,
          ...trTeams,
          ...trLeagues,
          ...trHeader,
          ...trRules,
          ...trAuth,
          ...trAdmin,
          ...trStandings,
          ...trTransfercenter,
          ...trCaptain,
          player: trPlayer,
          dashboard: trDashboard.dashboard,
          transfers: trTransfers,
          contracts: trContracts,
          common: {
            offline: "Şu Anda Çevrimdışı",
            live: "CANLI",
            viewers: "izleyici",
            watchNow: "Şimdi İzle",
            openInBrowser: "Tarayıcıda Aç"
          }
        },
        tickets: trTickets,
        notifications: trNotifications
      }
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18next;
